import { render, staticRenderFns } from "./NotaDinas.vue?vue&type=template&id=bf55d160&"
import script from "./NotaDinas.vue?vue&type=script&lang=js&"
export * from "./NotaDinas.vue?vue&type=script&lang=js&"
import style0 from "./NotaDinas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports